import { mobilePaddingX } from '../../theme/mobileLayout'

export const contactSectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export const contactInnerSx = {
  maxWidth: 1520,
  mx: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '80px', md: 12, lg: '150px' },
}

export const contactSplitSectionSx = {
  display: 'flex',
  flexDirection: { xs: 'column', lg: 'row' },
  gap: { xs: 4, md: 6, lg: '394px' },
  alignItems: 'flex-start',
  width: '100%',
}

export const contactSectionTitleSx = {
  fontSize: { xs: 28, md: 32, lg: 30 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
  flexShrink: 0,
}

/** Figma 800px → 600px — social platform link row in Connect With Us */
export const contactSocialLinksBoxSx = {
  display: 'flex',
  gap: '24px',
  width: '100%',
  maxWidth: { xs: '100%', md: 600 },
  flexWrap: 'nowrap',
}
